import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { initGA4, pageView } from "@/analytics/ga4";

/**
 * GA4RouteTracker — initializes GA4 once and emits a single `page_view` on
 * every React Router navigation. Renders nothing. No-op when GA4 is disabled.
 */
export default function GA4RouteTracker() {
    const location = useLocation();

    useEffect(() => {
        initGA4();
    }, []);

    useEffect(() => {
        pageView(location);
    }, [location.pathname, location.search, location.hash]);

    return null;
}
